import { useEffect } from "react";

import { useLDClient } from "launchdarkly-react-client-sdk";

import { useAppSelector } from "../store/hooks";
import { LaunchDarklyFlags } from "./flags";
import { RatingOptions } from "./types";

export const ldIdentify = (ldClient: any, id: string) => {
  if (!ldClient) return;

  ldClient.identify({ key: id });
};

export const getUserOptions = (ldclient: any) => {
  const getLdFlagValue = (flagType: string, defaulValue: any) => ldclient && ldclient.variation
    ? ldclient.variation(flagType, defaulValue)
    : defaulValue;

  const enableExperience3 = getLdFlagValue(
    LaunchDarklyFlags.EnableExperience3,
    true
  );

  const mobileNotificationFlag = getLdFlagValue(
    LaunchDarklyFlags.mobileNotificationFlag,
    false
  );
  const enableAdminFeatures = getLdFlagValue(
    LaunchDarklyFlags.enableAdminFeatures,
    false
  );

  const bannerFireworks = getLdFlagValue(
    LaunchDarklyFlags.bannerFireworks,
    false
  );

  const enableWeighingScaleToggle = getLdFlagValue(
    LaunchDarklyFlags.enableWeighingScaleToggle,
    false
  );
  const enableBannerRecipes = getLdFlagValue(
    LaunchDarklyFlags.enableBannerRecipes,
    true
  );
  const enableFavouritesMob = getLdFlagValue(
    LaunchDarklyFlags.enableFavouritesMob,
    false
  );
  const enableViewRecipeMob = getLdFlagValue(
    LaunchDarklyFlags.enableViewRecipeMob,
    false
  );

  const referralString = getLdFlagValue(
    LaunchDarklyFlags.referralWithReviewContent,
    null
  );

  const enableAlgoliaSearch = getLdFlagValue(
    LaunchDarklyFlags.algolia_search,
    false
  )
  const mobExternalLink = getLdFlagValue(
    LaunchDarklyFlags.mobExternalLinks,
    []
  )
  const shouldShowBanner = getLdFlagValue(
    LaunchDarklyFlags.shouldShowBanner,
    false
  )

  const ratingOptions: RatingOptions = getLdFlagValue(
    LaunchDarklyFlags.ratingOptions,
    {},
  )

  const syncup = getLdFlagValue(
    LaunchDarklyFlags.syncup,
    false,
  )

  const enableSorting = getLdFlagValue(LaunchDarklyFlags.enableSorting, true);

  const recipeOrdering = getLdFlagValue(LaunchDarklyFlags.recipeOrdering, []);

  const enableExperience3Mob = getLdFlagValue(LaunchDarklyFlags.enableExperience3Mob, false);

  const i18n = getLdFlagValue(LaunchDarklyFlags.Internationalisation, []);

  const enableMealPlan = getLdFlagValue(LaunchDarklyFlags.enableMealPlan, false);

  const enableMealPlanChallenge = getLdFlagValue(LaunchDarklyFlags.enableMealPlanChallenge, false);

  const mealPlanQuickOptions = getLdFlagValue(LaunchDarklyFlags.mealPlanQuickOptions, []);
  const posthogSessionReplay = getLdFlagValue(LaunchDarklyFlags.posthogSessionReplay, false);
  const requiresProvisioning = getLdFlagValue(LaunchDarklyFlags.requiresProvisioning, false);

  return {
    mobileNotificationFlag,
    enableExperience3,
    enableAdminFeatures,
    enableWeighingScaleToggle,
    enableSorting,
    recipeOrdering,
    bannerFireworks,
    enableBannerRecipes,
    referralString,
    enableExperience3Mob,
    enableFavouritesMob,
    enableViewRecipeMob,
    enableAlgoliaSearch,
    mobExternalLink,
    shouldShowBanner,
    ratingOptions,
    i18n,
    enableMealPlan,
    mealPlanQuickOptions,
    syncup,
    posthogSessionReplay,
    enableMealPlanChallenge,
    requiresProvisioning
  };
};

export const UseGetFlag = () => {
  const user = useAppSelector((state) => state.main.user);
  const ldClient = useLDClient();
  useEffect(() => {
    if (!user) return;
    ldIdentify(ldClient, user.id);
  }, [ldClient, user]);

  const { enableAdminFeatures, enableExperience3, enableWeighingScaleToggle, mobileNotificationFlag, enableSorting, recipeOrdering, bannerFireworks, enableBannerRecipes, referralString, enableFavouritesMob, enableViewRecipeMob, enableExperience3Mob, enableAlgoliaSearch, mobExternalLink, shouldShowBanner, ratingOptions, i18n, enableMealPlan, mealPlanQuickOptions, syncup, enableMealPlanChallenge, posthogSessionReplay, requiresProvisioning } =
    getUserOptions(ldClient);
  return { enableAdminFeatures, enableExperience3, enableWeighingScaleToggle, mobileNotificationFlag, enableSorting, recipeOrdering, bannerFireworks, enableBannerRecipes, referralString, enableFavouritesMob, enableViewRecipeMob, enableExperience3Mob, enableAlgoliaSearch, mobExternalLink, shouldShowBanner, ratingOptions, i18n, enableMealPlan, mealPlanQuickOptions, syncup, enableMealPlanChallenge, posthogSessionReplay, requiresProvisioning };
};